module.exports = __webpack_public_path__ + "media/images/views/home/home-features-photo-2-0b29b07d9bd3926953cc6a4a9b8c1eeb.png";